import React from "react";
import { func, bool, any } from "prop-types";

import "./table-button.m.css";

const TableButton = ({ children, selected, onClick, disabled }) => (
  <button styleName={selected ? "button selected" : "button"} onClick={onClick} disabled={disabled}>
    {children}
  </button>
);

TableButton.propTypes = {
  onClick: func,
  children: any,
  selected: bool,
  disabled: bool
};

export default TableButton;
